var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{staticClass:"audio",attrs:{"src":require("@/assets/auto/iphoneWeChat.mp3"),"muted":_vm.muted,"preload":"auto","id":"audioAuto"}}),_c('audio',{staticClass:"audio",attrs:{"src":require("@/assets/auto/gift.mp3"),"muted":_vm.muted,"preload":"auto","id":"giftAudio"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }